/**
 * Conditional Fields Display Logic
 * Manages showing/hiding of fields based on conditional logic
 */

(function ($) {
  "use strict";

  // Initialize conditional fields on page load
  function initConditionalFieldsDisplay() {
    const fields = window.hcpEditEntityData
      ? window.hcpEditEntityData.allFields || []
      : [];

    if (fields.length === 0) {
      return;
    }

    // Build a map of field_id => conditional logic
    const conditionalMap = {};
    fields.forEach(function (field) {
      if (field.conditional_logic) {
        conditionalMap[field.id] = field.conditional_logic;
      }
    });

    if (Object.keys(conditionalMap).length === 0) {
      return; // No conditional fields
    }

    // Initialize visibility on load
    updateConditionalFieldsVisibility(conditionalMap);

    // Update visibility when parent fields change
    $(document).on(
      "change input",
      'input[name^="field_"], select[name^="field_"], textarea[name^="field_"]',
      function () {
        const name = $(this).attr("name") || "";
        const match = name.match(/^field_(\d+)/);
        const fieldId = match ? match[1] : null;
        updateConditionalFieldsVisibility(conditionalMap, fieldId);
      },
    );
  }

  // Update visibility of conditional fields
  function updateConditionalFieldsVisibility(conditionalMap, changedFieldId) {
    Object.keys(conditionalMap).forEach(function (fieldId) {
      const logic = conditionalMap[fieldId];
      const shouldShow = evaluateConditional(logic);
      const $wrapper = $('.field-wrapper[data-field-id="' + fieldId + '"]');

      if ($wrapper.length) {
        if (shouldShow) {
          $wrapper.slideDown(200);
        } else {
          $wrapper.slideUp(200);
        }
      }
    });
  }

  // Evaluate if a conditional should be displayed
  function evaluateConditional(logic) {
    if (!logic || !logic.parent_field_id || !logic.values) {
      return true; // Show by default if invalid logic
    }

    const parentFieldId = logic.parent_field_id;
    const allowedValues = logic.values.map(function (v) {
      return parseInt(v);
    });

    // Get parent field value
    const fieldName = "field_" + parentFieldId;
    const $parentField = $('[name="' + fieldName + '"]');
    const $parentMulti = $('[name="' + fieldName + '[]"]');

    if (!$parentField.length && !$parentMulti.length) {
      return true; // Parent field not found, show field
    }

    // Handle multiselect (checkboxes with [] name)
    if ($parentMulti.length) {
      const selectedValues = $parentMulti
        .filter(":checked")
        .map(function () {
          return parseInt($(this).val());
        })
        .get();
      return selectedValues.some(function (v) {
        return allowedValues.includes(v);
      });
    }

    // Handle checkbox/radio groups
    if ($parentField.is(":checkbox") || $parentField.is(":radio")) {
      const selectedValue = $('input[name="' + fieldName + '"]:checked').val();
      if (selectedValue) {
        const valInt = parseInt(selectedValue);
        return allowedValues.includes(valInt);
      }
      return false;
    }

    // Handle select or hidden input (custom select stores value in hidden input)
    if ($parentField.is("select") || $parentField.is('input[type="hidden"]')) {
      const selectedValue = $parentField.val();
      if (selectedValue) {
        const valInt = parseInt(selectedValue);
        return allowedValues.includes(valInt);
      }
      return false;
    }

    // For other fields, shouldn't be conditional (TEXT, TEXTAREA, etc)
    return true;
  }

  // Expose globally
  window.hcpConditionalFieldsDisplay = {
    init: initConditionalFieldsDisplay,
  };

  // Initialize on document ready
  $(document).ready(function () {
    initConditionalFieldsDisplay();
  });
})(jQuery);
